/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import { WrappedComponentProps, injectIntl } from '@kyruus/intl';
import { DEFAULTS } from '@kyruus/provider-components';

import {
  EmptyStars,
  StyledStarOutline,
  FilledStars,
  StyledStar,
  StarWrapper,
  SummaryStars
} from './styles';

interface ProfileStarRatingProps {
  rating: number;
  starSize: number;
  widthAccuracyCorrection: number;
}

/**
 * Method to create an array of JSX icons.
 * @param {Component} Icon The Icon to populate the array.
 * @param {number} num The desired length of the icon array.
 * @param {size} num The desired size of the icon.
 * @return {JSX[]} An array with all the icons.
 */
const iconArrayCreator = (
  Icon: React.ElementType<{ size: string; displayName?: string }>,
  num: number,
  size: number
): React.ReactElement[] => {
  const icons = [];
  for (let i = 0; i < num; i++) {
    icons.push(
      <Icon
        size={`${size}px`}
        key={`${Icon.displayName}-${i}`}
        aria-hidden={true}
      />
    );
  }
  return icons;
};

const StarRating = ({
  rating,
  starSize,
  widthAccuracyCorrection
}: ProfileStarRatingProps & WrappedComponentProps): React.ReactElement => {
  // Get the rating scale
  const ratingScale = DEFAULTS.PROVIDER_RATING_SCALE;

  const filledPercent = `${rating / (0.01 * ratingScale)}%`;

  return (
    <SummaryStars
      aria-hidden={true}
      //@ts-ignore: non-intrinsic attributes for emotion styling
      ratingScale={ratingScale}
      starSize={starSize}
      widthAccuracyCorrection={widthAccuracyCorrection}
    >
      <StarWrapper>
        <EmptyStars>
          {iconArrayCreator(StyledStarOutline, ratingScale, starSize)}
        </EmptyStars>
        <FilledStars
          //@ts-ignore: non-intrinsic attributes for emotion styling
          filledPercent={filledPercent}
        >
          {iconArrayCreator(StyledStar, ratingScale, starSize)}
        </FilledStars>
      </StarWrapper>
    </SummaryStars>
  );
};

export default injectIntl(StarRating);
